var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBacklog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 15.5L9.875 13L10.8417 12.0333L12.1667 13.3583L15.1583 10.3667L16.125 11.5417L12.1667 15.5ZM8.66667 15.5H2.16667C1.24167 15.5 0.5 14.7583 0.5 13.8333V2.16667C0.5 1.24167 1.24167 0.5 2.16667 0.5H13.8333C14.7583 0.5 15.5 1.24167 15.5 2.16667V8.66667C14.9917 8.375 14.4333 8.16667 13.8333 8.06667V2.16667H2.16667V13.8333H8.06667C8.16667 14.4333 8.375 14.9917 8.66667 15.5ZM8 12.1667H3.83333V10.5H8V12.1667ZM10.2333 8.83333H3.83333V7.16667H12.1667V8.06667C11.4583 8.18333 10.8083 8.45 10.2333 8.83333ZM12.1667 5.5H3.83333V3.83333H12.1667",
    fill: "#909CA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacklog);
export default __webpack_public_path__ + "static/media/backlog.60f9329488c1bded3787de94515a58b4.svg";
export { ForwardRef as ReactComponent };